module.exports = __webpack_public_path__ + "static/media/OSMB03.22f0ce78.jpg";